import { DropdownOption } from '@anytag/shared-types';
import { DropdownMenu, DropdownMenuProps } from '../DropdownMenu';
import { Button, ButtonProps } from './button';

export type ButtonDropdownProps<T extends DropdownOption> = ButtonProps &
  Pick<DropdownMenuProps<T>, 'options' | 'onSelectOption' | 'align' | 'side' | 'withinPortal' | 'id'> & {
    dropdownClassName?: string;
  };

export const ButtonDropdown = <T extends DropdownOption>({
  options,
  onSelectOption,
  dropdownClassName,
  align = 'start',
  side = 'bottom',
  variant = 'solid',
  withinPortal = true,
  ...restProps
}: ButtonDropdownProps<T>) => {
  const handleSelectOption = (option: DropdownOption) => {
    onSelectOption?.(option as T);
  };

  return (
    <DropdownMenu
      trigger={<Button className="min-w-[inherit]" variant={variant} {...restProps} />}
      options={options}
      className={dropdownClassName}
      onSelectOption={(props) => handleSelectOption(props)}
    />
  );
};
